import { RetailView } from "../../View/AppView/RetailView";
import { ViewController, AuthorityCodeChangeEvent, ModelUpdateEvent, TimeoutEvent, TimeUpdateEvent, MaintenanceEvent,
         ChannelSwitchEvent, DomInstantiateEvent, LocalStorageController, Setup, VideoView } from "@gaming/srvg-classes-core";
import { ChunkIndicatorViewController } from "./ChunkIndicatorViewController";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";
import { RetailCallToActionViewController } from "./RetailCallToActionViewController";
import { GroupTablesGalleryViewController } from "./GroupTablesGalleryViewController";
import { ProgressbarViewController } from "./ProgressbarViewController";
import { ChunkChangeEvent } from "../../Event/ChunkChangeEvent";
import { COUNTDOWN_START_PREMATCH } from "./CallToActionViewController";
import { CompetitionTimelineViewController } from "./CompetitionTimelineViewController";
import { ChunkIndicatorView } from "../../View/ChunkIndicatorView";
import { CHUNK_MODEL_CHUNK } from "../../Model/ChunkModel";
import { COMPETITION_MODEL_COMPETITION } from "../../Model/CompetitionModel";

export class RetailViewController extends ViewController {
    retailView: RetailView;
    callToActionViewController: RetailCallToActionViewController;
    groupTablesGalleryViewController: GroupTablesGalleryViewController;
    competitionTimelineViewController: CompetitionTimelineViewController;
    progressbarViewController: ProgressbarViewController;
    chunkIndikatorViewController: ChunkIndicatorViewController;
    switchSetupTimeout: any;
    isTerminal: boolean;

    constructor(options) {
        options = options || {};
        options.view = options.retailView;
        super(options);

        this.retailView = options.retailView;
        this.callToActionViewController  = null;
        this.switchSetupTimeout = null;

        srvg.product.instanceType=='Terminal' ? this.isTerminal = true : this.isTerminal = false;

        // force reload - activate for all retail instances
        if(srvg.featuresInstances.getEnableForceReloadFullRetail()){
            srvg.flost.setForceReloadCompatibleWithMinute(srvg.featuresInstances.getForceReload());
        }else {
            // activate only for flost
            if(srvg.videooptions.flostVideosets) {
                srvg.flost.setForceReloadCompatibleWithMinute(srvg.featuresInstances.getForceReload());
            }
        }

        // connect components
        this.retailView.addSubscriberForEvent( this, DomInstantiateEvent );
        app.timelineController.addSubscriberForEvent(srvg.maintenance, MaintenanceEvent);
        app.timelineController.timeline.currentCompetitionModel.addSubscriberForEvent(app.customerIntegrationController, ModelUpdateEvent);
        app.timelineController.addSubscriberForEvent(app.server, TimeUpdateEvent);
        app.timelineController.addSubscriberForEvent(this, PhaseChangeEvent);
        if(app.inactivityController) {
            app.inactivityController.addSubscriberForEvent(app.timelineController, TimeoutEvent);
            app.inactivityController.addSubscriberForEvent(app.customerIntegrationController, TimeoutEvent);
        }
        this.retailView.selectedChunkModel.addSubscriberForEvent(this, ModelUpdateEvent);

        // start components
        app.timelineController.startPolling();
        if(app.inactivityController) {
            app.inactivityController.startWaiting();
        }
        if(srvg.debugView) {
            srvg.debugView.registerEventHandlers();
        }
    }

    handleDomInstantiateEvent(event: DomInstantiateEvent, provider) {
        if(this.retailView.findSubViewBySelector('#calltoactionView', true)) {
            this.callToActionViewController = this.addChildViewController(new RetailCallToActionViewController({
                callToActionView: this.retailView.findSubViewBySelector('#calltoactionView', true),
                chunkModel: this.retailView.selectedChunkModel,
                countdownStartMode: COUNTDOWN_START_PREMATCH
            }));
            this.addSubscriberForEvent(this.callToActionViewController, ChunkChangeEvent);
            app.timelineController.addSubscriberForEvent(this.callToActionViewController, PhaseChangeEvent);
            app.timelineController.addSubscriberForEvent(this.callToActionViewController, AuthorityCodeChangeEvent);
        }
        if(this.retailView.findSubViewBySelector('#groupTablesGalleryView', true)) {
            this.groupTablesGalleryViewController = this.addChildViewController( new GroupTablesGalleryViewController( {
                galleryView: this.retailView.findSubViewBySelector('#groupTablesGalleryView', true)
            }));
        }
        if(this.retailView.findSubViewBySelector('#chunkIndicatorView', true)) {
            this.chunkIndikatorViewController = this.addChildViewController(new ChunkIndicatorViewController({
                chunkIndicatorView: this.retailView.findSubViewBySelector('#chunkIndicatorView', true)
            }));
            app.timelineController.addSubscriberForEvent(this.chunkIndikatorViewController, AuthorityCodeChangeEvent);
        }
        if(this.retailView.findSubViewBySelector('#competitionTimelineView', true)) {
            this.competitionTimelineViewController = this.addChildViewController( new CompetitionTimelineViewController({
                competitionTimelineView: this.retailView.findSubViewBySelector('#competitionTimelineView', true)
            }));
        }

        if(app.videoSourceController instanceof LocalStorageController) {
            // Video views are initialized now, local storage can start
            this.log('Initializing Local Storage');
        }
        else {
            this.log('Initializing Streaming Source');
        }

        // Must be called after the video views have been created and connected to their video channels.
        app.videoSourceController.connect();

        // prepare for channelswitch if not disabled in features and when terminal - handle ChannelSwitchEvent
        if(this.isTerminal && !srvg.featuresInstances.getDisableRetailChannelSwitch()) {
            srvg.eventExchange.addEventHandler(this, 'all', ChannelSwitchEvent);
        }

        this.progressbarViewController = new ProgressbarViewController({
            progressbarView: this.retailView.findSubViewBySelector('#progressbarView', true)
        });
        app.timelineController.addSubscriberForEvent(this.progressbarViewController, PhaseChangeEvent);
    }

    handlePhaseChangeEvent(event:PhaseChangeEvent, provider) {
        var nowInMs = app.server.getTimeInMs();

        // TODO: why was this inserted ? we have that play stop api triggers already in Retailview.ts ?!
        /*
        if(event.phase && event.phase.willEndCurrentCycle()) {
            var nowInMs = app.server.getTimeInMs();

            // Workaround solution using flowplayer 7 
            $('.VideoView').each(function () {
                if ($(this).hasClass('is-loading')) {
                    $(this).removeClass('is-loading').addClass('is-playing');
                }
            });

            if(srvg.featuresInstances.getStopVideoInBettingAndResult() && srvg.videoplayer && srvg.videoplayer.type == 'flowplayer') {
                switch (event.phase.name) {
                    case 'post_match':
                    case 'pause':
                        this.stopAllPlayer(true);
                        break;
                    case 'betstop':
                    case 'match':
                    case 'ticker':
                    case 'pre_league':
                    case 'pre_cup':
                        this.playAllPlayer(false);
                        break;
                    case 'post_league':
                    case 'post_group':
                    case 'post_cup':
                        this.playAllPlayer(true);
                        break;
                    case 'pre_match':
                        let endphaseInSec = event.phase.end * 1000 - nowInMs;
                        if (endphaseInSec < 3000) { // < 3 sek - start directly
                            this.playAllPlayer(false);
                        } else {
                            let that = this;
                            that.stopAllPlayer(false);
                            setTimeout(function () {
                                that.playAllPlayer(true);
                            }, endphaseInSec - 2500);
                        }
                        break;
                }
            }
        }
        */

        var currentRound = event.chunk.round();
        if(!currentRound) {
            console.warn('RetailViewController: Cannot determine current round from chunk', event.chunk);
            return;
        }
        var currentCycle = event.phase.cycle();
        if(!currentCycle) {
            console.warn('RetailViewController: Cannot determine current cycle from phase', event.phase);
            return;
        }
        var currentRoundPart = event.chunk.roundPart();
        if(typeof currentRoundPart!='number') {
            console.warn('RetailViewController: Cannot determine current roundPart from chunk', event.chunk);
            return;
        }

        let endphaseInSec = event.phase.end * 1000 - nowInMs;
        this.setSetupForRoundAndCycle(currentRound, currentCycle, currentRoundPart, 0, endphaseInSec);

        var setBodyData = {
            'round': currentRound,
            'cycle': currentCycle,
            'chunk': event.chunk.nr,
            'mode': srvg.product.name
        };
        for(var key in setBodyData) {
            $('body').attr('data-'+key, setBodyData[key]);
        }

    }

    setSetupForRoundAndCycle(currentRound:string, currentCycle:string, part:number, index:number, endphaseInMs?:number, rotate?:boolean) {
        var endphaseInSec = endphaseInMs/1000;
        if(this.switchSetupTimeout) {
            window.clearTimeout(this.switchSetupTimeout);
            this.switchSetupTimeout = null;
        }
        var newSetup: Setup = null;
        var currentRoundCycleSetup = this.retailView.roundCycleSetups[currentRound][part] ? this.retailView.roundCycleSetups[currentRound][part] : this.retailView.roundCycleSetups[currentRound][0];
        if(currentRoundCycleSetup && currentRoundCycleSetup[currentCycle] && currentRoundCycleSetup[currentCycle][index]) {
            newSetup = currentRoundCycleSetup[currentCycle][index].setup;
            var that = this;
            if(currentRoundCycleSetup[currentCycle].length>index+1) {
                // this is not the only setup in this cycle -> set timeout for displaying next setup
                this.switchSetupTimeout = window.setTimeout(
                    function() {
                        that.setSetupForRoundAndCycle(currentRound, currentCycle, part, index+1, endphaseInMs-currentRoundCycleSetup[currentCycle][index].display_length*1000);
                    },
                    currentRoundCycleSetup[currentCycle][index].display_length*1000
                );
            }else if(currentRoundCycleSetup[currentCycle][index].display_length !== null){ // new condition: screen setup should rotate
                // check time is bigger than threshold, but only if is is rotating.
                // check if min_display_length is available. Default is 5 sec
                var minDisplayLength = 5;
                if (typeof currentRoundCycleSetup[currentCycle][index].min_display_length !== "undefined"){
                    minDisplayLength = currentRoundCycleSetup[currentCycle][index].min_display_length;
                }

                if (minDisplayLength <= endphaseInSec){
                    this.switchSetupTimeout = window.setTimeout(
                        function() {
                            that.setSetupForRoundAndCycle(currentRound, currentCycle, part, 0, endphaseInMs-currentRoundCycleSetup[currentCycle][index].display_length*1000);
                        },
                        currentRoundCycleSetup[currentCycle][index].display_length*1000
                    );
                }
            }
        }
        if(!this.retailView.currentSetupModel.get() || this.retailView.currentSetupModel.get()!=newSetup) {
            this.retailView.setCurrentSetup(newSetup, false);
        }
    }

    clearTimeouts() {
        if(this.switchSetupTimeout) {
            window.clearTimeout(this.switchSetupTimeout);
            this.switchSetupTimeout = null;
        }
    }

    handleModelUpdateEvent(event: ModelUpdateEvent, provider) {
        if(event.propertyName == CHUNK_MODEL_CHUNK) {
            this.triggerEvent(new ChunkChangeEvent(event.propertyValue));

            var chunkIndicatorView:ChunkIndicatorView = <ChunkIndicatorView>this.retailView.findSubViewBySelector('#chunkIndicatorView', true);
            if(chunkIndicatorView) {
                chunkIndicatorView.chunk = event.propertyValue;
                chunkIndicatorView.refresh();
            }
        }else if(event.propertyName == COMPETITION_MODEL_COMPETITION && event.propertyPreviousValue && srvg.featuresInstances.getReloadAfterCompetition()) {
            window.location.reload();
        }
    }

    private stopOrPlayVideo(id, method) {
        let fetchElement = <VideoView>this.retailView.findSubViewBySelector('#'+id, true);
        if(fetchElement && fetchElement.player && typeof fetchElement.player.api[method] === "function") {
            fetchElement.player.api[method]();
        }
    }

    /*
    private stopAllPlayer(force) {
        var that = this;
        $('.VideoView').each(function(){
            if (force || $(this).hasClass('is-playing')) {
                that.stopOrPlayVideo($(this).attr('id'), 'unload');
            }
        });
    }
    private playAllPlayer(force) {
        var that = this;
        $('.VideoView').each(function(){
            if (force || $(this).hasClass('is-paused')) {
                that.stopOrPlayVideo($(this).attr('id'), 'load');
            }
        });
    }
    */

    handleChannelSwitchEvent(event:ChannelSwitchEvent, provider:any) {
        // if not disabled in features
        if(this.isTerminal && !srvg.featuresInstances.getDisableRetailChannelSwitch()) {

            // store channel for channel switch
            srvg.videooptions.defaultchannel = event.newChannel;

            // find all videoviews that should be switched and set model
            for(let i in this.retailView.backLayerView.subViews) {
                let view = this.retailView.backLayerView.subViews[i];
                let videoView: VideoView = <VideoView>view;

                if (srvg.flostCheck.isFlost !== true) {
                    // new playerclass channel switching
                    var hd = srvg.player._anchor.getAttribute("data-status").indexOf("is-hd") > -1 ? true : false;
                    var channel = event.newChannel;

                    srvg.player._domElement.dispatchEvent(
                        new CustomEvent('Playerclass_channelSwitchEvent'+srvg.player._playerManagerId, {
                            detail: {
                                call: 'channelSwitch', channel: srvg.videooptions.defaultchannel, hd: hd, internal: false
                            }
                        }));

                }

            }
        }
    }

}